var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterjoinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 94,
    viewBox: "0 0 84 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3403_8491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35767 61.9635V72.0072L42.8893 92.4758L82.6423 70.9321V24.633L43.5138 2.34082V39.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35767 63V25.3545L38.5718 3.33447",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92456 67.1621L42.8077 83.1803L76.6005 64.481L43.2557 45.3599L9.92456 67.1621Z",
    fill: "#DD44B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3403_8491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterjoinus);
export default __webpack_public_path__ + "static/media/footerjoinus.e4eb6f73f1b4908d0a3f04f43ff0b320.svg";
export { ForwardRef as ReactComponent };